var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54017 11.9048H16.6205V14.2857H5.54017V11.9048ZM8.31025 21.4286H2.77008V2.38095H12.4654V8.33333H19.3906V12.0238L22.1607 9.64286V7.14286L13.8504 0H2.77008C2.03541 0 1.33083 0.25085 0.811338 0.697365C0.291847 1.14388 0 1.74948 0 2.38095V21.4286C0 22.06 0.291847 22.6656 0.811338 23.1122C1.33083 23.5587 2.03541 23.8095 2.77008 23.8095H8.31025V21.4286ZM5.54017 19.0476H11.2188L12.4654 17.9762V16.6667H5.54017V19.0476ZM22.4377 13.0952C22.5762 13.0952 22.8532 13.2143 22.9917 13.3333L24.7922 14.881C25.0693 15.119 25.0693 15.5952 24.7922 15.8333L23.4072 17.0238L20.4986 14.5238L21.8837 13.3333C22.0222 13.2143 22.1607 13.0952 22.4377 13.0952ZM22.4377 17.7381L13.9889 25H11.0803V22.5L19.5291 15.2381L22.4377 17.7381Z",
    fill: "#002954"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c0ee810fde838cf0272ba7d2da115af0.svg";
export { ForwardRef as ReactComponent };